import { NgModule } from '@angular/core';
import { NkContentComponent } from './content.component';

@NgModule({
  imports: [NkContentComponent],
  exports: [NkContentComponent],
})
export class NkContentModule {}
